import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaFabricante from './Components/TabelaTipoCombustivel'
import TabelaTipoCombustivel from './Components/TabelaTipoCombustivel'


const mockPermissions = [
  { id: 1, tipocombustivel: 'Gasolina', ativo: true },
  { id: 2, tipocombustivel: 'Etanol', ativo: true },
  { id: 3, tipocombustivel: 'Diesel', ativo: true },
  { id: 4, tipocombustivel: 'GNV', ativo: false },
  { id: 5, tipocombustivel: 'Flex', ativo: true },
  { id: 6, tipocombustivel: 'Elétrico', ativo: false },
  { id: 7, tipocombustivel: 'Híbrido', ativo: true },
  { id: 8, tipocombustivel: 'Biodiesel', ativo: true },
  { id: 9, tipocombustivel: 'Hidrogênio', ativo: false },
  { id: 17, tipocombustivel: 'Propano', ativo: true },
];


function TipoCombustivel() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox',isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Tipo de Combustível', key: 'tipocombustivel', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Tipo de Combustível'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaTipoCombustivel headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default TipoCombustivel